import axios from "axios";

export const API_BASE = process.env.REACT_APP_WHOONOW_API_URL;

export const api = axios.create({ baseURL: `${API_BASE}/api`, timeout: 30000 });

const ACCESS_KEY = "whoonow_access";
const REFRESH_KEY = "whoonow_refresh";
const USER_KEY = "whoonow_user";

export const tokenStore = {
  get access() { return localStorage.getItem(ACCESS_KEY); },
  get refresh() { return localStorage.getItem(REFRESH_KEY); },
  get user() {
    try { return JSON.parse(localStorage.getItem(USER_KEY)); } catch { return null; }
  },
  save({ access_token, refresh_token, user }) {
    if (access_token) localStorage.setItem(ACCESS_KEY, access_token);
    if (refresh_token) localStorage.setItem(REFRESH_KEY, refresh_token);
    if (user) localStorage.setItem(USER_KEY, JSON.stringify(user));
  },
  clear() {
    localStorage.removeItem(ACCESS_KEY);
    localStorage.removeItem(REFRESH_KEY);
    localStorage.removeItem(USER_KEY);
  },
};

api.interceptors.request.use((config) => {
  const t = tokenStore.access;
  if (t) config.headers.Authorization = `Bearer ${t}`;
  return config;
});

let refreshing = null;
api.interceptors.response.use(
  (res) => res,
  async (error) => {
    const original = error.config;
    if (error.response?.status === 401 && !original._retry && tokenStore.refresh) {
      original._retry = true;
      try {
        refreshing = refreshing || axios.post(`${API_BASE}/api/auth/refresh`, { refresh_token: tokenStore.refresh });
        const { data } = await refreshing;
        refreshing = null;
        tokenStore.save(data);
        original.headers.Authorization = `Bearer ${data.access_token}`;
        return api(original);
      } catch (e) {
        refreshing = null;
        tokenStore.clear();
        window.location.href = "/login";
      }
    }
    return Promise.reject(error);
  }
);

export const errMsg = (e) => e?.response?.data?.detail || "Si è verificato un errore. Riprova.";

export const uploadMedia = async (file) => {
  const form = new FormData();
  form.append("file", file);
  const { data } = await api.post("/media/upload", form, { headers: { "Content-Type": "multipart/form-data" } });
  return data;
};
